import { useRouteMatch } from 'react-router-dom';
import routes from '@config/routes';
import spamPosts, {
  getById as getPostById,
  getList as getPosts,
  setFilters as setPostsFilters,
} from '@stores/spam';
import spamComments, {
  getById as getCommentById,
  getList as getComments,
  setFilters as setCommentsFilters,
} from '@stores/spamComments';

interface SpamFilters {
  spam: any;
  getById: any;
  getList: any;
  setFilters: any;
}

const useSpamFilters = (): SpamFilters => {
  const isComments = useRouteMatch({
    path: routes.spamComments.path,
  });
  if (isComments) {
    return {
      spam: spamComments,
      getById: getCommentById,
      getList: getComments,
      setFilters: setCommentsFilters,
    };
  } else {
    return {
      spam: spamPosts,
      getById: getPostById,
      getList: getPosts,
      setFilters: setPostsFilters,
    };
  }
};

export default useSpamFilters;
